import {
  DEFAULT_CREDIT_CARD_BRAND,
  CREDIT_CARD_BRANDS,
  FAST_PAYOUTS_STATUS,
} from '@/components/fast-payouts/consts'
import moment from 'moment'
import { MOMENT_FORMATS } from '@/localize'

type FastPayoutsStatus = ValueOf<typeof FAST_PAYOUTS_STATUS>
type CreditCardBrand = keyof typeof CREDIT_CARD_BRANDS

export function getCreditCardImage ({ brand }: { brand?: string }) {
  const default_card = DEFAULT_CREDIT_CARD_BRAND

  return CREDIT_CARD_BRANDS[brand as CreditCardBrand] || CREDIT_CARD_BRANDS[default_card]
}

export function fastPayoutsEnabledFor (status: FastPayoutsStatus): boolean {
  return ([
    FAST_PAYOUTS_STATUS.AVAILABLE,
    FAST_PAYOUTS_STATUS.AVAILABLE_TOMORROW,
    FAST_PAYOUTS_STATUS.BLOCKED,
    FAST_PAYOUTS_STATUS.WRONG_DEBIT_CARD,
  ] as string[]).includes(status)
}

export function formatDate (date: moment.MomentInput): string {
  return moment(date).format(MOMENT_FORMATS.MMM_D_YYYY)
}

export function formatTime (date: moment.MomentInput): string {
  return moment(date).format(MOMENT_FORMATS.hm_A)
}

export function getFormattedCardNumber (number?: string | null): string {
  if (number) {
    return `**** **** **** ${number}`
  }
  return ''
}

export function getFormattedBankAccountNumber (number?: string | null): string {
  if (number) {
    return `** **** **** **** ${number}`
  }
  return ''
}

export function fastPayoutLimitsShowEnabledFor (status: FastPayoutsStatus): boolean {
  return !([
    FAST_PAYOUTS_STATUS.HIDDEN,
    FAST_PAYOUTS_STATUS.MISSING_KYC,
  ] as string[]).includes(status)
}
